import { action } from 'satcheljs';

export const getGoDaddyDomainDetails = action('getGoDaddyDomainDetails');
